import type { ReactElement } from 'react';
import type { RouteObject } from 'react-router';
import { TabRedirect } from './TabRedirect';

/**
 * A record page's tabs as routes, `<recordPath>/<tab>`, with the bare `<recordPath>` redirecting to the first tab.
 * A link can then land on the tab it means (the compliance overview opens Documents), and a reload stays on it.
 * This is the section-tab rule (CLAUDE.md → Tabs are routes) applied one level down.
 */
export function recordTabRoutes<T extends string>(recordPath: string, tabs: readonly [T, ...T[]], render: (tab: T) => ReactElement): RouteObject[] {
  return [{ path: recordPath, element: <TabRedirect tab={tabs[0]} /> }, ...tabs.map((tab) => ({ path: `${recordPath}/${tab}`, element: render(tab) }))];
}
